module.exports = __webpack_public_path__ + "img/top24.56788c9d.png";